import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreLibModule } from 'core-lib';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { DrawerModule } from 'primeng/drawer';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { FilestoreBrowserComponent } from './filestore-browser/filestore-browser.component';
import { FilestoreOperationLogComponent } from './filestore-operation-log/filestore-operation-log.component';
import { FileStoreRoutingModule } from './filestore-routing.module';
import { FilestoreUploadWebComponent } from './filestore-upload-web/filestore-upload-web.component';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {VideojsplayerModule } from 'core-ui';
import { ProgressBarModule } from 'primeng/progressbar';





@NgModule({
  declarations: [
    FilestoreBrowserComponent,
    FilestoreUploadWebComponent,
    FilestoreOperationLogComponent,
  ],
    imports: [
        CoreLibModule,
        CommonModule,
        FileStoreRoutingModule,
        TableModule,
        ToolbarModule,
        ButtonModule,
        ToastModule,
        MessageModule,
        DialogModule,
        FormsModule,
        InputTextModule,
        BreadcrumbModule,
        FileUploadModule,
        MenuModule,
        ConfirmDialogModule,
        InputTextModule,
        DrawerModule,
        ProgressSpinnerModule,
        ProgressBarModule,
        VideojsplayerModule
    ],
  exports:[

  ]
})
export class FilestoreModule { }
